
import { EVENTS } from '@empathybroker/ebx-gluon';
import DefaultOpen from '@empathybroker/ebx-gluon/dist/components/pure/default-open.vue';
import { Component } from 'vue-property-decorator';

@Component
export default class CdlOpen extends DefaultOpen {
  domTriggersSelector: string;
  domTriggerEvent: string;
  onTriggerEvent: () => void;
  isDomTriggerTarget: (event: Event) => boolean;

  protected updateListeners() {
    document.removeEventListener(this.domTriggerEvent, this.eventListener);
    document.addEventListener(this.domTriggerEvent, this.eventListener);
    document.removeEventListener('input', this.eventListener);
    document.addEventListener('input', this.eventListener);
  }

  protected eventListener(event: Event) {
    if (this.isDomTriggerTarget(event)) {
      this.onTriggerEvent();
      const clientSearchBox = (event.target as HTMLElement).querySelector('input');
      this.setQueryFromInput(clientSearchBox);
    }
  }

  mounted() {
    // If when this component is mounted, the open input is focused, open EmpathyX with the typed text.
    const openInput = document.querySelector<HTMLInputElement>(`${ this.domTriggersSelector } input`);
    if (openInput && openInput === document.activeElement) {
      this.onTriggerEvent();
      this.setQueryFromInput(openInput);
    }
  }

  protected setQueryFromInput(input: HTMLInputElement | undefined) {
    if (input && input.value) {
      this.$x.emit(EVENTS.InputQueryChanged, input.value);
      input.value = '';
    }
  }

  render() {}
}
